module.exports = __webpack_public_path__ + "img/icon1.81ed74ed.png";